import React from 'react';
interface StatusBadgeProps {
  status: 'New' | 'Attempted' | 'Connected' | 'Converted';
}
export function StatusBadge({
  status
}: StatusBadgeProps) {
  const styles = {
    New: 'bg-slate-100 text-slate-700 border-slate-200',
    Attempted: 'bg-orange-50 text-orange-700 border-orange-200',
    Connected: 'bg-blue-50 text-blue-700 border-blue-200',
    Converted: 'bg-green-50 text-green-700 border-green-200'
  };
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${styles[status]}`} data-id="element-180">
      {status}
    </span>;
}